import {
  LOGIN,
  LOGOUT,
  CHECK_ORGA_PROFILE,
  GET_PROFILE,
  AUTOMATIC_LOGOUT,
  AUTOMATIC_LOGOUT_CLOSE,
  GOOGLE_SIGNUP,
  SET_AUTH_DIALOG,
} from "../types/userTypes";

const initialState = {
  isAuth: false,
  token: null,
  orga_id: null,
  profile: null,
  redirectUrl: null,
  automaticLogout: false,
  ssoUser: {},
  authDialog: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isAuth: true,
        token: action.payload.token,
        orga_id: action.payload.organization_id,
        redirectUrl: action.payload.redirectUrl,
      };
    case AUTOMATIC_LOGOUT:
      return {
        ...state,
        automaticLogout: true,
      };
    case AUTOMATIC_LOGOUT_CLOSE:
      return {
        ...state,
        automaticLogout: false,
      };
    case LOGOUT:
      return {
        ...state,
        isAuth: false,
        token: null,
        orga_id: null,
        profile: null,
        redirectUrl: null,
      };
    case CHECK_ORGA_PROFILE:
      return { ...state, orga_id: action.payload };
    case GET_PROFILE:
      return { ...state, profile: action.payload };
    case GOOGLE_SIGNUP:
      return { ...state, ssoUser: action.payload };
    case SET_AUTH_DIALOG:
      return { ...state, authDialog: action.payload };
    default:
      return state;
  }
};

export default userReducer;
